// Legal documents served on superluxury.io.
// Privacy and Cookie Policy are the approved iubenda texts (latest update: April 22, 2026).
import { cookiePolicy } from './cookiePolicy';
import { privacyPolicy } from './privacyPolicy';
import { creditPartners } from './credits';

export type LegalSection = {
  heading: string;
  paragraphs: string[];
  list?: string[];
  /** Paragraphs shown after the list */
  after?: string[];
  subsections?: LegalSection[];
  /** Smaller heading — used for individual third-party services */
  minor?: boolean;
  /** Tight line spacing — used for address blocks */
  compact?: boolean;
  /** Optional external link shown after the paragraphs */
  link?: { label: string; href: string };
};

export type LegalDocument = {
  slug: 'privacy-policy' | 'cookie-policy' | 'imprint';
  title: string;
  updated: string;
  intro: string;
  sections: LegalSection[];
};

const imprint: LegalDocument = {
  slug: 'imprint',
  title: 'Imprint',
  updated: '19 October 2026',
  intro: 'Provider information for superluxury.io.',
  sections: [
    {
      heading: 'Provider Information',
      paragraphs: [
        'Company Name: KAYS VENTURES FZCO',
        'Registered Office: Dubai Silicon Oasis, DDP, Building A1, Dubai, United Arab Emirates',
        'Phone Number: 00971 / 505254282',
        'Email Address: hey@superluxury.io',
        'Website: superluxury.io',
        'Managing Directors: Adrian Kays',
        'Trade License Number: 16239',
        'VAT Identification Number: Pending application',
        'Regulatory Authority: IFZA',
      ],
      compact: true,
    },
    {
      heading: 'Responsible for Content (pursuant to § 18 Abs. 2 MStV)',
      paragraphs: ['Adrian Kays', 'Dubai Silicon Oasis, DDP, Building A1, Dubai, United Arab Emirates'],
      compact: true,
    },
    {
      heading: 'Liability for content',
      paragraphs: [
        'The content of this website has been prepared with care. Listings, availability and services are shared for information only, are offered to members on introduction, and may change without notice.',
      ],
    },
    {
      heading: 'Copyright',
      paragraphs: [
        'All text, images, video and design on this website are the property of KAYS VENTURES FZCO (Superluxury) or its partners and may not be reproduced without written permission.',
      ],
    },
    ...creditPartners.map((partner) => ({
      heading: `Credits — ${partner.name}`,
      paragraphs: [
        ...(partner.description ? [partner.description] : []),
        partner.statement,
        ...(partner.note ? [partner.note] : []),
      ],
      link: partner.link,
      compact: true,
    })),
  ],
};

export const legalDocuments: LegalDocument[] = [privacyPolicy, cookiePolicy, imprint];
